import styled from 'styled-components';

export default styled.div`
  width: 0.5rem;
  position: absolute;
  left: 1px;
  top: 0.5rem;
  bottom: -0.5rem;
  border-right: 2px dashed #e6e6e6;
`;
